import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  TextField,
} from "@mui/material";

const cellSx = {
  backgroundColor: "rgba(47, 53, 71, 0.9)",
  border: "1.5px solid #fff",
  color: "white",
  padding: "10px 8px",
};

const numberSx = {
  ...cellSx,
  textAlign: "center",
  fontWeight: 700,
  fontSize: 22,
};

// Utility to format number with two decimals
const formatNum = (num) =>
  num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const InternalSeveranceTable = ({ internalSeverance = 0, onValuesChange }) => {
  const [editableSeverance, setEditableSeverance] = useState(formatNum(internalSeverance));

  useEffect(() => {
    setEditableSeverance(formatNum(internalSeverance));
  }, [internalSeverance]);

  const handleChange = (event) => {
    const val = event.target.value;
    // Allow empty or numeric with decimal input only
    if (val === "" || /^\d*\.?\d*$/.test(val)) {
      setEditableSeverance(val);
      if (typeof onValuesChange === "function") {
        onValuesChange(Number(val) || 0);
      }
    }
  };

  return (
    <Box mt={4}>
      <Typography variant="h6" mb={2} fontWeight="bold" color="white">
        Indemnizacion Interna
      </Typography>
      <TableContainer component={Paper} sx={{ background: "rgba(47,53,71,0.9)" }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell sx={{ ...cellSx, fontWeight: 700 }}>Indemnizacion Interna (Total)</TableCell>
              <TableCell
                sx={{
                  ...numberSx,
                  background: "rgba(34,189,110,0.15)",
                  color: "#3afa60",
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: 20,
                }}
              >
                <TextField
                  variant="standard"
                  value={editableSeverance}
                  onChange={handleChange}
                  inputProps={{
                    style: { color: "white", fontWeight: "bold", textAlign: "center" },
                    inputMode: "decimal",
                    autoComplete: "off",
                    spellCheck: false,
                  }}
                  sx={{ width: "140px" }}
                  placeholder="0.00"
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default InternalSeveranceTable;
